import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import {MdbTableDirective, MdbTablePaginationComponent} from 'angular-bootstrap-md';
import { UsersService } from '../services/users.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';



export interface Events {
    name: string;
    email: string;
    role: string; 
    country:string;
    status:string;

  }

@Component({
  selector: 'app-usermanagement',
  templateUrl: './usermanagement.component.html',
  styleUrls: ['./usermanagement.component.scss']
})
export class UsermanagementComponent implements OnInit {

  @ViewChild(MdbTablePaginationComponent, { static: true }) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective, {static: true}) mdbTable: MdbTableDirective;

  headElements = ['Name', 'Email','Status', 'Action'];
  searchText: string = '';
  previous: string;

  usersList:any = [];

  usersForm: FormGroup

  isBlocked

  blocked:string = "blocked"
  active:string = "active"


  constructor(private cdRef: ChangeDetectorRef, private usersService: UsersService, private formBuilder: FormBuilder) {
  }

  @HostListener('input') oninput() {
      this.searchItems();
  }

  ngOnInit() {

    this.usersForm = this.formBuilder.group({
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      email: ['', Validators.required]
    });

      
      this.usersService.getUsersList("user").then((res: any) => {
      
        if (res.success) {
          console.log(res)
          for (let i = 0; i < res.users.data.length; i++) {
            if(res.users.data[i].block == 1) { this.isBlocked = "active"} else if (res.users.data[i].block == 3){ this.isBlocked = "blocked"}
            this.usersList.push({ 
              id: res.users.data[i].id, 
              first_name: res.users.data[i].first_name,
              last_name: res.users.data[i].last_name,
              country: res.users.data[i].country,
              email: res.users.data[i].email,
              block: this.isBlocked
             });
          }
          console.log(this.usersList)
          this.mdbTable.setDataSource(this.usersList);
      this.previous = this.mdbTable.getDataSource();
      }}) 
        .catch((error) => {
          console.log(error)
        })
  }

  ngAfterViewInit() {
    this.mdbTablePagination.setMaxVisibleItemsNumberTo(10);

    this.mdbTablePagination.calculateFirstItemIndex();
    this.mdbTablePagination.calculateLastItemIndex();
    this.cdRef.detectChanges();
  }

  searchItems() {
      const prev = this.mdbTable.getDataSource();
      if (!this.searchText) {
          this.mdbTable.setDataSource(this.previous);
          this.usersList = this.mdbTable.getDataSource();
      }
      if (this.searchText) {
          this.usersList = this.mdbTable.searchLocalDataBy(this.searchText);
          this.mdbTable.setDataSource(prev);
      }
  }

  sendInv(){
    console.log(this.usersForm.value)
    this.usersService.addUser(this.usersForm.value).then((res: any) => {
      if (res.success) {
     console.log(res)
     alert(res.message)
    }
     else alert(res.error)
  })
  }

  block(id){
    console.log(id)
    this.usersService.blockUser(id).then((res: any) => {
      console.log(res)
      for (let i=0; i<this.usersList.length; i++){
        if(this.usersList[i].id == id){
      if(this.usersList[i].block == "blocked") { this.usersList[i].block = "active"} 
      else if (this.usersList[i].block == "active"){ this.usersList[i].block = "blocked"}
      }
    }
   }) 
  }

  promoteUser(id){
    console.log(id)
    this.usersService.promoteToAdmin(id).then((res:any) =>{
      if (res.success) {
        console.log(res)
        alert(res.message)
       }
        else alert(res.error)
    })
  }
}
